<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<div>
			<el-table :data="tableData" style="width: 100%" border>
				
				 <el-table-column v-for="(item,index) in attrList" v-if="attrList.length!=0" :label="item.goodsAttrKeyName" align="center">
				 	<template slot-scope="scope">
				 		{{JSON.parse(scope.row.goodsSpecs)[item.goodsAttrKeyName]}}
				 	</template>							
				 </el-table-column>
				<el-table-column prop="price" width="150" label="单品价格" align="center">
				</el-table-column>
				<el-table-column prop="integral" width="150" label="积分" align="center">
				</el-table-column>
				<el-table-column prop="weight" width="150" label="重量" align="center">
				</el-table-column>
				<el-table-column prop="promotionCoupons" width="150" label="奖励积分" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>			
					</template>
				</el-table-column>
			</el-table>
		</div>
		
		<el-dialog v-if="dialogVisible"  :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal='false'  width="400px">
			<el-form :model="form">
				<el-form-item :label="item.goodsAttrKeyName" label-width='100px' v-for="(item,index) in attrList" :key='index'>
					<el-select v-model="form.goodsSpecs[item.goodsAttrKeyName]" placeholder="请选择" >
						<el-option v-for="(it,n) in item.goodsAttrValues.split(',')" :label="it" :value="it">
						</el-option>
					</el-select>
				</el-form-item>									
				<el-form-item label="单品价格" label-width='100px'>
					<el-input v-model="form.price" maxlength="18" autocomplete="off" placeholder="请输入单品价格"></el-input>
				</el-form-item>		
				<el-form-item label="单品积分" label-width='100px'>
					<el-input v-model.number="form.integral" maxlength="18" autocomplete="off" placeholder="请输入单品积分"></el-input>	
				</el-form-item>	
				<el-form-item label="重量（kg）" label-width='100px'>
					<el-input v-model="form.weight" maxlength="18" autocomplete="off" placeholder="请输入重量（kg）"></el-input>	
				</el-form-item>		
				<el-form-item label="赠送上级奖励积分" label-width='130px'>
					<el-input v-model="form.promotionCoupons" maxlength="18" autocomplete="off" placeholder="请输入奖励积分"></el-input>
				</el-form-item>
				<el-form-item label="复购赠送上级奖励" label-width='130px'>
					<el-input v-model="form.presentParent" maxlength="18" autocomplete="off" placeholder="请输入奖励积分"></el-input>
				</el-form-item>
				<el-form-item label="JKS支付计算" label-width='130px'>
					<el-input v-model="form.useJksParam" maxlength="18" autocomplete="off" placeholder="N"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub">确 定</el-button>
			</div>
		</el-dialog>	
	</div>
</template>

<script>
	export default {
		props: ["goodsId"],
		data() {
			return {
				attrList: [],
				tableData:[],
				item:{},
				form:{},
				dialogVisible:false,
				isAdd:true
			}
		},
		created() {
			this.getAttr()
			
		},
		methods: {
			//删除
			del(row){
				// this.form.tabData.splice(index,1);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/goods/delGoodsSku?" + this.$qs.stringify({
						goodsSkuId: row.goodsSkuId
					})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getSku()
						}
					})
				}).catch(() => {});
			},
			//新增
			add() {				
				this.form=JSON.parse(JSON.stringify(this.item))
				this.dialogVisible = true
				this.isAdd = true
			},
			//修改
			edit(row) {
				this.form=row
				console.log(this.form.goodsSpecs)
				this.form.goodsSpecs=JSON.parse(this.form.goodsSpecs)
				this.dialogVisible = true
				this.isAdd = false			
			},
			
			//提交
			sub() {
				for (var i = 0; i < this.attrList.length; i++) {
					var item = this.attrList[i]
					if(this.form.goodsSpecs[item.goodsAttrKeyName]=="" ||this.form.goodsSpecs[item.goodsAttrKeyName].length==0){
						this.$message('请选择'+item.goodsAttrKeyName);
						return false
					}
				}
				if (!this.istwoNum(this.form.price)) {
					this.$message('请输入大于0的整数或者保留两位小数的单品价格');
					return false
				}
				// if (this.form.integral===0) {
				// 	this.$message('请输入正确的积分，积分为大于0的正整数');
				// 	return false
				// }
				if (!this.isNum(this.form.integral)) {
					this.$message('积分输入为数字');
					return false
				}
				if (!this.istwoNum(this.form.weight)) {
					this.$message('请输入大于0的整数或者保留两位小数的重量');
					return false
				}
				this.form.weight=parseFloat(this.form.weight)
				this.form.goodsSpecs=JSON.stringify(this.form.goodsSpecs)
				this.form.modifyTime=''
				this.form.modifyUserId=''
				console.log(JSON.stringify(this.form))
				var url = this.isAdd ? "/goods/addSku" : "/goods/updateSku"
				if (this.isAdd) {
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getSku()
						}
					})
				} else {
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getSku()
						}
					})
				}

			},

			//获取属性数据
			getAttr() {
				this.httpPost("/goods/getAttr?" + this.$qs.stringify({
					goodsId: this.goodsId
				})).then(res => {
					if (res.code == 200) {
						this.attrList = res.data						
						if(this.attrList.length>0){
							var goodsSpecs = {}
							for (var i = 0; i < this.attrList.length; i++) {
								var item = this.attrList[i]
								goodsSpecs[item.goodsAttrKeyName] = ''
							}
							this.item={
								goodsId: this.goodsId,
								goodsSkuId: '',
								goodsSpecs: goodsSpecs,
								price: '',
								integral:"",
								weight:""
							}
							this.getSku()
						}else{
							this.$message.error("请先设置属性")
						}
					}
				})
			},
			
			//获取单品数据
			getSku() {
				this.httpPost("/goods/getSku?" + this.$qs.stringify({
					goodsId: this.goodsId
				})).then(res => {
					if (res.code == 200) {
						this.tableData = res.data
					}
				})
			},

		},


	}
</script>

<style scoped lang='scss'>
	/* .page {
		padding: 20px 0;
	} */
	.conten {
		padding: 0px 20px;
		height: 60vh;
		overflow-y: auto;
	}
	
</style>
